// NPM packages
import React from 'react';
import styled from '@emotion/styled';
import { Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

// All other imports
import Link from 'components/core/Link';

const BannerContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.primary.main,
  color: '#ffffff',
  padding: theme.spacing(1.5, 2),
  textAlign: 'center',
  position: 'relative',
  zIndex: 1100,
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
}));

const BannerContent = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '1rem',
  fontWeight: theme.typography.fontWeightMedium,
  flexWrap: 'wrap',
  overflowWrap: 'break-word',
  wordBreak: 'break-word',
}));

const BannerIcon = styled(InfoIcon)(({ theme }) => ({
  fontSize: '1.25rem',
  [theme.breakpoints.down('md')]: {
    fontSize: '1.1rem',
  },
}));

const BannerLink = styled(Link)(({ theme }) => ({
  color: '#ffffff',
  textDecoration: 'underline',
  fontWeight: 600,
  '&:hover': {
    color: theme.palette.primary.light,
    textDecoration: 'underline',
  },
  '&:focus': {
    outline: '2px solid #ffffff',
    outlineOffset: '2px',
    borderRadius: '2px',
  },
}));

interface BannerProps {
  message?: string;
  linkText?: string;
  linkUrl?: string;
}

const Banner: React.FC<BannerProps> = ({
  message = 'There will be a MSD Community of Practice webinar on MSD-LIVE on 12-May at 1pm Eastern. The goal of the webinar is to demonstrate the new interactive data exploration features in v3. ',
  linkText = 'Registration',
  linkUrl = 'https://cornell.zoom.us/meeting/register/zMN-KUXWSOmP7k79P5asiQ#/registration'
}) => {
  return (
    <BannerContainer role="banner" aria-label="Announcement banner">
      <BannerContent>
        <BannerIcon aria-hidden="true" />
        <span>
          {message}{' '}
          <BannerLink to={linkUrl} aria-label={`${linkText} for webinar`}>
            {linkText}
          </BannerLink>
          {' '}is required. We hope to see you there!
        </span>
      </BannerContent>
    </BannerContainer>
  );
};

export default Banner;
